import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AcCheckboxComponent} from './ac-checkbox.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {InfraPipesModule} from "../../pipes/infra.pipes.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatCheckboxModule,
        InfraPipesModule
    ],
    declarations: [
        AcCheckboxComponent,
    ],
    entryComponents: [
        AcCheckboxComponent,
    ],
    exports: [
        AcCheckboxComponent,
    ]
})
export class AcCheckboxModule {
}
